<template>
    <div class="row" >
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-success o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>R$ {{to_pay}}</h6>
                        <small>Contas a pagar hoje</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-primary o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>R$ {{to_receive}}</h6>
                        <small>Contas a receber hoje</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-secondary o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>R$ {{received}}</h6>
                        <small>Contas pagas hoje</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-sm-6 mb-3">
            <div class="card text-white bg-danger o-hidden h-100">
                <div class="card-body">
                    <div class="">
                        <h6>R$ {{payd}}</h6>
                        <small>Contas recebidas hoje</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		name: 'cardListDashFinanceiro',
        data(){
            return{
                to_pay       : 0,
                to_receive    : 0,
                received         : 0,
                payd    : 0,

				interval		: 0
            }
		},
		computed: {
			getToken(){
				return this.$store.getters.getToken
			}
		},
		methods: {
			getData: function(){
				fetch(server + 'resumos/caixa', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
					.then(response => (response.json()) )
					.then(responseJSON => {
                        if(responseJSON.data == true){
                            this.to_pay      = responseJSON.response[0].to_pay
                            this.to_receive  = responseJSON.response[0].to_receive
                            this.received  = responseJSON.response[0].received
                            this.peyd   = responseJSON.response[0].payd
                        }else{
                            this.to_pay      = 0
                            this.to_receive  = 0
                            this.received  = 0
                            this.peyd   = 0
                        }
					})
					.catch(error => {
						console.log('{Erro exception}', '=>', error)
					})
			},
			syncData: function(){
				this.interval = setInterval(() => {
					this.getData()
				}, 30000)
			}
		},
		mounted(){
			this.getData()
		},
		created(){
			
        },
        beforeRouterEnter(to, from, next){
            this.syncData()
        },
        beforeRouterLeave(to, from, next){
            clearInterval(this.interval)
        }
	}
</script>

<style scoped>
</style>
